import React from 'react';
// components
import App2 from './App2';
import { MediaQuery, useMediaQuery } from 'react-responsive';
import App3 from './App3';
import Projects from './components/Projects';
import {  BrowserRouter as Router, Routes, Route } from "react-router-dom"


function App () {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isDesktopOrLaptop = useMediaQuery({ minWidth: 1224 });
  return (
   <>
    
    {isDesktopOrLaptop && <App2/>}
    {isMobile && <App3/>}
   </>
  );
};

export default App;
